module.exports = __webpack_public_path__ + "img/nibnut.2644f385.png";